import React, { useState } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import BeautyInsiderModuleLayout from 'components/Content/BeautyInsider/BeautyInsiderModuleLayout/BeautyInsiderModuleLayout';
import {
    Box, Text, Link, Image
} from 'components/ui';
import localeUtils from 'utils/LanguageLocale';
import PointsActivityCard from 'components/Content/BeautyInsider/BeautyInsiderModules/PointsActivityCard/PointsActivityCard';
import LoadingActivityCardWrapper from 'components/Content/BeautyInsider/BeautyInsiderModules/LoadingActivityCard/LoadingActivityCardWrapper';

const getText = localeUtils.getLocaleResourceFile(
    'components/Content/BeautyInsider/BeautyInsiderModules/ShortPointsActivity/locales',
    'ShortPointsActivity'
);

const contentZone = (records, error, onToggle, expandedGroupId) => {
    if (error && records === null) {
        return <Text>{getText('errorLoadingPoints')}</Text>;
    }

    if (records === null) {
        return <LoadingActivityCardWrapper numberOfCards={3} />;
    }

    if (records.length === 0) {
        return (
            <Box>
                <Image
                    display='block'
                    size={[48, 120]}
                    marginBottom={[4, 4]}
                    src='/img/ufe/no-points.svg'
                />
                <Text>{getText('noPoints')}</Text>
            </Box>
        );
    }

    return (
        <Box marginTop={2}>
            {records.slice(0, 3).map((record, index) => (
                <PointsActivityCard
                    key={record.groupId || index}
                    record={record}
                    onToggle={() => onToggle(record.groupId)}
                    isExpanded={expandedGroupId === record.groupId}
                />
            ))}
        </Box>
    );
};

const headerCtaTitle = records => {
    if (!records || records?.length <= 3) {
        return null;
    }

    return (
        <Link
            color='blue'
            children={getText('viewAll')}
            href='/profile/BeautyInsider/MyPoints'
        />
    );
};

const ShortPointsActivity = ({ records, error }) => {
    const [expandedGroupId, setExpandedGroupId] = useState(null);

    const handleCardToggle = groupId => {
        // If clicking the same card, collapse it; otherwise expand the new one
        setExpandedGroupId(expandedGroupId === groupId ? null : groupId);
    };

    return (
        <div>
            <BeautyInsiderModuleLayout
                title={getText('title')}
                isSingleContentZone
                headerCtaTitle={headerCtaTitle(records)}
                content={contentZone(records, error, handleCardToggle, expandedGroupId)}
            />
            <Text
                marginTop={4}
                is='p'
                color='gray'
                fontSize='sm'
                children={getText('doNotSeePoints')}
            />
        </div>
    );
};

export default wrapFunctionalComponent(ShortPointsActivity, 'ShortPointsActivity');
